import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from 'react-google-charts';
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import BucketsTableMaxCoolent_Jupiter from "./BucketsTableMaxCoolent_Jupiter";
import BucketsTableMaxCoolentOut_Jupiter from "./BucketsTableMaxCoolentOut_Jupiter";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar, getElementAtEvent } from "react-chartjs-2";
// import { Chart, registerables } from 'chart.js';
// Chart.register(...registerables);
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let res_result
let Maxchartdata
let bartype
function MaxCoolentTemp_Jupiter({ apiend, gloablfilter, type, chartSelectedBCS}) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("Max coolant temp(oC) - Slow chrg");
  let barcolor1
  let barcolor2

  let modal_title = "";
  

  const appyData = (data) => {
    res_result = data;
    let responce = {
      "<24": 0,
      "26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      "44": 0,
      "46": 0,
      ">=46": 0,
    };
    
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      let id = 0
      temp_result.map(d => {
        let value = d[chartSelectedBCS].value;
        if (value > 0 && value < 24) {
          responce["<24"] = responce["<24"] + 1;
        } else if (value >= 24 && value < 26) {
          responce["26"] = responce["26"] + 1;
        } else if (value >= 26 && value < 28) {
          responce["28"] = responce["28"] + 1;
        } else if (value >= 28 && value < 30) {
          responce["30"] = responce["30"] + 1;
        } else if (value >= 30 && value < 32) {
          responce["32"] = responce["32"] + 1;
        } else if (value >= 32 && value < 34) {
          responce["34"] = responce["34"] + 1;
        } else if (value >= 34 && value < 36) {
          responce["36"] = responce["36"] + 1;
        } else if (value >= 36 && value < 38) {
          responce["38"] = responce["38"] + 1;
        } else if (value >= 38 && value < 40) {
          responce["40"] = responce["40"] + 1;
        } else if (value >= 40 && value < 42) {
          responce["42"] = responce["42"] + 1;
        } else if (value >= 42 && value < 44) {
          responce["44"] = responce["44"] + 1;
        } else if (value >= 44 && value < 46) {
          responce["46"] = responce["46"] + 1;
        } else if (value >= 46) {
          responce[">=46"] = responce[">=46"] + 1;
        }
      })


      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", "46", ">=46"]
      loop_keys.map(x => {
          // res_result_final.push([x, responce[x], barcolor2]);
          if(type === 'Slow'){
            res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${"#348393"}}`]);
          }else{
            res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${"#F39C48"}}`]);
          }
      })
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }

    const labels = ["<24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", "46", ">=46"];
    Maxchartdata = {
      labels,
      datasets: [
        {
          label: chartSelectedBCS,
          data: responce,
          // backgroundColor:  (chartSelectedBCS === 'slow') ? "#348393" : "#F39C48",
          backgroundColor: barcolor2,
          borderColor: "black",
          borderWidth: 1,
          
        }
      ]
    };
  }
  let hAxis = {};

  if (apiend === "rangebarchart") {
    modal_title = "Real World Range Distribution";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  if (apiend == "energybarchart") {
    modal_title = "Net Energy consumption";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }
  const chartref = useRef()

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,

    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          // text: 'Temperature (oC)'
          text: chartSelectedBCS
        },
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        }
      },
    },

    plugins: {
      legend: {
        position: false
      },
    }
  };
  
  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: chartSelectedBCS,
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
  };

  useEffect(() => {
    if (type === "Slow") {
      fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/" + apiend, body: { filterdata: gloablfilter, dropdown:chartSelectedBCS } }, appyData)
      SetChartName("Max coolant temp(oC) - Slow chrg")
      barcolor1 = "#89CCD8";
      barcolor2 = "#348393"
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/" + "maxcoolenttempfast", body: { filterdata: gloablfilter, dropdown:chartSelectedBCS } }, appyData)
      SetChartName("Max coolant temp(oC) - Fast chrg")
      barcolor1 = "#FFD1A4"
      barcolor2 = "#F39C48"
    }
  }, [gloablfilter, type,chartSelectedBCS])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                : <NoData_Jupiter />
              )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" options={options} data={chartdata} width="100%" height="230px" chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;
              if (count !== 0) {
                let filtered_temp = [];
                filtered_temp = apiresponce.filter(x => {
                  if (x[chartSelectedBCS].value< barvalue && x[chartSelectedBCS].value>= barvalue - 2) {
                    return x;
                  } else if (x[chartSelectedBCS].value> 44 && x[chartSelectedBCS].value<= 46 && barvalue === "46") {
                    return x
                  } else if (x[chartSelectedBCS].value< 24 && barvalue === "<24") {
                    return x
                  }
                })

                function compareObjects(object1, object2, key) {
                  const obj1 = object1[chartSelectedBCS].value
                  const obj2 = object2[chartSelectedBCS].value
                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$("#sid").modal('show');
              }
            }
          }
        }
        ]}/>
        : <NoData_Jupiter />
      )}

      <div className="modal fade" id={"sid"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  
                  {(chartSelectedBCS === 'Max_BCS_Coolant_Out') ? <BucketsTableMaxCoolentOut_Jupiter data={filteredData} /> : <BucketsTableMaxCoolent_Jupiter data={filteredData} />}
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxCoolentTemp_Jupiter;